import exploitation from 'components/propTypes/exploitation';
import API from 'services/API';

export const getExploitationInformations = (id) => API.get(`/exploitations/${id}`);

// CULTURES

export const getCulturesByExploitationIdForSimulation = (exploitationId) =>
  API.get(`/exploitations/${exploitationId}/simulation/cultures`);

export const getCulturesByExploitationId = (id, organic) =>
  API.get(`/exploitations/${id}/cultures`, {
    params: {
      organic,
    },
  });

export const updateCulture = (id, data, exploitationCultureId) =>
  API.patch(`/exploitations/${id}/cultures/edit/${exploitationCultureId}`, data);

// EXPLOITATIONS

export const getConstraints = (cooperativeId) =>
  API.get(`/constraints?cooperative=${cooperativeId}`);

export const getObjectives = () => API.get(`/objectives`);

// PARCELS

export const getParcelsByExploitation = (id) =>
  API.get(`/exploitations/${id}/parcels?version=full&by-years=false`);

export const getParcelsByExploitationForForecastCampaign = (id, forecastCampaign) =>
  API.get(`/exploitations/${id}/parcels?filter=${forecastCampaign}`);
export const addParcel = (idExploitation, data) =>
  API.post(`/exploitations/${idExploitation}/parcels`, data);

export const updateParcel = (idExploitation, data) =>
  API.patch(`/exploitations/${idExploitation}/parcels`, data);

export const removeParcel = (idExploitation, idParcel) =>
  API.delete(`/exploitations/${idExploitation}/parcels/remove/${idParcel}`);

export const createGroupementParcel = (idExploitation, data) =>
  API.post(`/exploitations/${idExploitation}/parcels/groupement`, data);

export const editGroupementParcel = (idExploitation, data, id) =>
  API.patch(`/exploitations/${idExploitation}/parcels/groupement/${id}`, data);

export const removeGroupementParcel = (idExploitation, id) =>
  API.delete(`/exploitations/${idExploitation}/parcels/groupement/${id}/delete`);

// GROUNDTYPE

export const getGroundTypeByExploitationId = (idExploitation) =>
  API.get(`ground-types/exploitations/${idExploitation}`);

// EFFECTS

export const resetEffects = (exploitation, culture, organic) =>
  API.patch(`/exploitations/${exploitation.id}/cultures/reset/${culture.id}?organic=${organic}`);

export const resetCultures = (exploitation, organic) =>
  API.patch(`/exploitations/${exploitation.id}/cultures/reset?organic=${organic}`);

export const resetGroundTypeEffects = (exploitation, organic) =>
  API.patch(`/exploitations/${exploitation.id}/gnd-type-effects/reset?organic=${organic}`);

export const resetRotationEffects = (exploitation) =>
  API.patch(`/exploitations/${exploitation.id}/rotation-effects/reset`);

// ARABLE

export const getArableSurface = (exploitationId) =>
  API.get(`/exploitations/${exploitationId}/arable`);

// IMPORT TELEPAC

export const ImportTelepac = (formData, exploitationId) =>
  API.post(`/exploitation/${exploitationId}/telepac`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  });

export default {
  getExploitationInformations,
};

// PROCEDURE CAMPAIGN

/**
 *
 * @param {*} fromLevel => 'cooperative' | 'sector', | 'exploitation'
 * @param {*} levelId => id of cooperative, sector or exploitation
 * @param {boolean} willOvertakeProcedure
 */
export const logToIniateProcedure = (fromLevel, levelId, willOvertakeProcedure) =>
  API.post(
    `/user/log/${fromLevel}/${levelId}${willOvertakeProcedure ? '?willOvertake=true' : ''}`,
    {}
  );
export const finalizeProcedure = (exploitationId, parcels) =>
  API.patch(`/exploitations/${exploitationId}/campaign`, parcels);

export const cancelProcedure = (exploitationId) =>
  API.delete(`/user/log/exploitation/${exploitationId}`);
